import { useEffect, useState } from 'react';
import methodModel from '../../../methods/methods';
import Html from './html';

function MultiSelectDropdown({
  intialValue,
  options,
  result,
  displayValue = 'name',
  placeholder = 'Select Option',
  className = '',
  required = false,
  closeMenuOnSelect = false,
  id,
}) {
  const [selectedValues, setSelectedValues] = useState([]);

  const handleChange = (e) => {
    const isAll = e.find((option) => option.value === 'all');
    if (isAll) {
      let value = [];
      value = options?.map((itm) => itm.id);
      result({ event: 'value', value });
    } else if(e.length===0){
      let value;
      result({event:'value',value});  
    } else{
      let value = [];
      value = e.map((itm) => itm.value);
      result({ event: 'value', value });
    }
    // let value = [];
    // value = e.map((itm) => {
    //   return itm.value;
    // });
    // result({ event: "value", value: value });
  };

  useEffect(() => {
    let value = [];
    if (intialValue?.length && options?.length) {
      value = intialValue?.map((itm) => ({
        ...methodModel.find(options, itm, 'id'),
        value: methodModel.find(options, itm, 'id')?.id || '',
        label:
          methodModel.find(options, itm, 'id')?.[displayValue] || 'Not Exist',
      }));
    }
    setSelectedValues(value);
  }, [intialValue, options]);

  return (
    <Html
      id={id}
      displayValue={displayValue}
      options={options}
      selectedValues={selectedValues}
      handleChange={handleChange}
      placeholder={placeholder}
      className={className}
      required={required}
      closeMenuOnSelect={closeMenuOnSelect}
    />
  );
}

export default MultiSelectDropdown;
